import { Box, Chip, Paper, Typography, useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import EditAmountDialog from "./ActionButtons/EditAmountDialog";
import { MOBILE_BREAKPOINT } from "utils/constants";

const paperSx = isMobile => ({
  width: isMobile ? "100%" : "90%",
  backgroundColor: "warning.light",
  border: "1px solid #BEBEBE",
});

const StatChip = ({ label, value }) => (
  <Chip
    label={
      <span>
        {label}: <strong>{`€${value}`}</strong>
      </span>
    }
    color="error"
    variant="outlined"
    sx={{ height: "auto", py: 0.5, "& .MuiChip-label": { whiteSpace: "normal", textAlign: "center" } }}
  />
);

const ScholarshipAmountSection = ({ budgetInfo, filters, scholarshipAmount, fetchApprovedApplications }) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Paper sx={{ ...paperSx(isMobile), pb: 4, ...(!budgetInfo?.structuralUnitBudget ? { mb: 8 } : { mb: 2 }) }}>
        <Typography
          align="center"
          color="primary"
          sx={{ fontSize: 18, pt: 1 }}
        >
          Бюджет за Университет
        </Typography>
        <Box
          p={2}
          sx={{ display: "flex", justifyContent: "center", gap: 2 }}
        >
          <StatChip
            label="Наличен бюджет за стипендии"
            value={budgetInfo?.totalBudget}
          />
          <StatChip
            label="Необходима сума за всички стипендии за семестъра"
            value={budgetInfo?.totalNeededAmount}
          />
          <StatChip
            label="Необходима сума за тип стипендия за семестъра"
            value={budgetInfo?.scholarshipTypeNeededAmount}
          />
          <StatChip
            label="Остатък бюджет"
            value={budgetInfo?.amountLeft}
          />
        </Box>
      </Paper>
      {budgetInfo?.structuralUnitBudget ? (
        <Paper sx={{ ...paperSx(isMobile), mb: 8 }}>
          <Typography
            align="center"
            color="primary"
            sx={{ fontSize: 18, pt: 1 }}
          >
            Бюджет за Факултет
          </Typography>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 2 }}
          >
            <StatChip
              label="Наличен бюджет за стипендии"
              value={budgetInfo?.structuralUnitBudget}
            />
            <StatChip
              label="Необходима сума за всички стипендии за семестъра"
              value={budgetInfo?.structuralUnitNeededAmount}
            />
            <StatChip
              label="Необходима сума за тип стипендия за семестъра"
              value={budgetInfo?.structuralUnitScholarshipTypeNeededAmount}
            />
            <StatChip
              label="Остатък бюджет"
              value={budgetInfo?.structuralUnitAmountLeft}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2 }}>
            <SecuredComponent permission={permissions.canUpdateScholarshipsAmount}>
              <EditAmountDialog
                type={filters.scholarshipType}
                category={filters.scholarshipCategory}
                amount={scholarshipAmount}
                fetchApprovedApplications={fetchApprovedApplications}
              />
            </SecuredComponent>
          </Box>
        </Paper>
      ) : null}
    </Box>
  );
};

export default ScholarshipAmountSection;
